/* tslint:disable */
/* eslint-disable */
/**
 * classes-service
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * An enumeration.
 * @export
 * @enum {string}
 */

export const Libraries = {
    _598322a5F2744cc5962a2cffd1f4a157: '598322a5-f274-4cc5-962a-2cffd1f4a157',
    D85929ddEacd45faB81b093293261b69: 'd85929dd-eacd-45fa-b81b-093293261b69',
    Ebd17df121084c3c8f19F38008869fa4: 'ebd17df1-2108-4c3c-8f19-f38008869fa4',
    _6ce06b0d004c49e08f1bCadc97400206: '6ce06b0d-004c-49e0-8f1b-cadc97400206',
    _4873ff1752624282A28cC8c40bf5fef6: '4873ff17-5262-4282-a28c-c8c40bf5fef6'
} as const;

export type Libraries = typeof Libraries[keyof typeof Libraries];



